import { render, staticRenderFns } from "./actualite.vue?vue&type=template&id=34ee7a48&scoped=true&"
import script from "./actualite.vue?vue&type=script&lang=js&"
export * from "./actualite.vue?vue&type=script&lang=js&"
import style0 from "./actualite.vue?vue&type=style&index=0&id=34ee7a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ee7a48",
  null
  
)

export default component.exports